module.exports = __webpack_public_path__ + "static/media/ano-novo-banner.8a5d2979.png";